export default __webpack_public_path__ + "static/media/eye.b81b3789.jpg";